import { useMutation } from "react-query";
import { postData } from "../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { appInsights } from "../../../config/appInsights";
import { message } from "antd";
import { errorHandler } from "../../../helpers/errorHandler";
import { IResponse } from "../../../interfaces/response";

export type TInitiateUserUnlockPayload = {
  ssoUserId: string;
  lockReasonId: number;
  lockReason: string;
  additionalLockDescription: string | null;
  unlockReasonId: number;
  additionalUnlockDescription: string;
  unlockReason: string;
};

const initiateUserUnlock = async (
  payload: TInitiateUserUnlockPayload,
): Promise<IResponse<any>> => {
  const { data } = await postData(ajaxEndpoints.INITIATE_USER_UNLOCK, payload);

  return data;
};

export function useInitiateUserUnlock() {
  const [mutate, result] = useMutation(
    (payload: TInitiateUserUnlockPayload) => initiateUserUnlock(payload),
    {
      onSuccess: (data) => {
        console.log("data: ", data);
        message.success(
          data?.message || "User unlock has been initiated successfully.",
        );
      },
      onError: (error) => {
        appInsights.trackException({
          exception: error,
          properties: { fileName: "useInitiateUserUnlock.ts" },
        });
        message.error(errorHandler(error));
      },
    },
  );

  return { mutate, result };
}
